/* Bellori — guide d'installation : pills modèles (?modele=), cotes par modèle, contexte Inbox,
   mobile ≤ 760 px = une étape à la fois + barre de progression sticky (#etape-N). */
(function () {
  'use strict';
  var root = document.querySelector('[data-inst]');
  if (!root) return;
  var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var models = {};
  try { models = JSON.parse((document.querySelector('[data-inst-models]') || {}).textContent || '{}'); } catch (e) {}
  var stepsWrap = root.querySelector('[data-inst-steps]');
  var steps = qsa('[data-inst-step]', root);
  var total = steps.length;
  var mq = window.matchMedia('(max-width: 760px)');
  var current = 1;
  var model = root.getAttribute('data-inst-model') || 'geneve';

  /* ---------- Modèle ---------- */
  function setModel(key, push) {
    if (!models[key]) return;
    model = key;
    root.setAttribute('data-inst-model', key);
    qsa('[data-inst-pill]', root).forEach(function (p) { p.setAttribute('aria-selected', p.getAttribute('data-inst-pill') === key ? 'true' : 'false'); });
    qsa('[data-inst-cotes-for]', root).forEach(function (el) { el.hidden = el.getAttribute('data-inst-cotes-for') !== key; });
    qsa('[data-inst-fiche-for]', root).forEach(function (el) { el.hidden = el.getAttribute('data-inst-fiche-for') !== key; });
    updateContext();
    if (push && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('modele', key);
      window.history.replaceState({}, '', url.toString());
    }
  }
  function updateContext() {
    var btn = root.querySelector('[data-inst-contact]');
    if (!btn) return;
    var name = (models[model] && models[model].name) || model;
    var stepEl = steps[current - 1];
    var stepTitle = stepEl ? (stepEl.getAttribute('data-title') || '') : '';
    var url = location.origin + location.pathname + '?modele=' + model + '#etape-' + current;
    btn.setAttribute('data-cd-ctx', 'Installation · ' + name + ' · étape ' + current + (stepTitle ? ' (' + stepTitle + ')' : '') + ' · ' + url);
  }
  root.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-inst-pill]');
    if (pill) { e.preventDefault(); setModel(pill.getAttribute('data-inst-pill'), true); return; }
    var go = e.target.closest('[data-inst-go]');
    if (go && mq.matches) {
      e.preventDefault();
      setStep(parseInt(go.getAttribute('data-inst-go'), 10), true);
    }
  });

  /* ---------- Étapes (mobile) ---------- */
  function headerHeight() {
    var h = document.querySelector('.bl-header');
    return h ? h.getBoundingClientRect().height : 0;
  }
  /* Décalage réel de la barre sticky = bas visible de l'en-tête (0 si l'en-tête a défilé hors écran) */
  function syncTop() {
    var h = document.querySelector('.bl-header');
    var top = h ? Math.max(0, Math.min(h.getBoundingClientRect().bottom, h.getBoundingClientRect().height)) : 0;
    document.documentElement.style.setProperty('--inst-top', Math.round(top) + 'px');
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!mq.matches || ticking) return;
    ticking = true;
    requestAnimationFrame(function () { syncTop(); ticking = false; });
  }, { passive: true });
  function setStep(n, scroll) {
    n = Math.max(1, Math.min(total, n || 1));
    current = n;
    steps.forEach(function (s, i) { s.classList.toggle('is-current', i + 1 === n); });
    var lbl = root.querySelector('[data-inst-progress-label]');
    if (lbl) lbl.textContent = 'Étape ' + n + ' / ' + total;
    qsa('[data-inst-bar]', root).forEach(function (b) {
      var i = parseInt(b.getAttribute('data-inst-bar'), 10);
      b.classList.toggle('is-done', i < n);
      b.classList.toggle('is-now', i === n);
    });
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.hash = 'etape-' + n;
      window.history.replaceState({}, '', url.toString());
    }
    if (scroll) {
      var top = stepsWrap.getBoundingClientRect().top + window.pageYOffset - 8;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    updateContext();
  }
  function stepFromHash() {
    var m = /#etape-(\d)/.exec(location.hash || '');
    return m ? parseInt(m[1], 10) : 1;
  }
  function applyMode() {
    var progress = root.querySelector('[data-inst-progress]');
    if (mq.matches) {
      syncTop();
      stepsWrap.classList.add('is-stepper');
      if (progress) progress.hidden = false;
      setStep(stepFromHash(), false);
    } else {
      stepsWrap.classList.remove('is-stepper');
      if (progress) progress.hidden = true;
      steps.forEach(function (s) { s.classList.remove('is-current'); });
      current = stepFromHash();
      updateContext();
    }
  }
  if (mq.addEventListener) mq.addEventListener('change', applyMode); else if (mq.addListener) mq.addListener(applyMode);
  window.addEventListener('hashchange', function () { if (mq.matches) setStep(stepFromHash(), true); else { current = stepFromHash(); updateContext(); } });
  window.addEventListener('resize', function () { if (mq.matches) syncTop(); });

  // Sur desktop, l'étape « en cours » pour le contexte Inbox = la dernière étape visible à l'écran
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (mq.matches) return;
      entries.forEach(function (en) {
        if (en.isIntersecting) { current = parseInt(en.target.getAttribute('data-inst-step'), 10) || current; updateContext(); }
      });
    }, { threshold: 0.6 });
    steps.forEach(function (s) { io.observe(s); });
  }

  // ?modele= : Liquid n'a pas accès à la query string → présélection côté client
  try { var qm = (new URLSearchParams(location.search).get('modele') || '').toLowerCase(); if (qm && models[qm]) model = qm; } catch (e) {}
  setModel(model, false);
  applyMode();
  document.addEventListener('shopify:section:load', function () { applyMode(); });
})();
